/* src/app/master-data/branches/edit-branch/edit-branch.component.css */
/*# sourceMappingURL=edit-branch.component-S562RFHJ.css.map */
